export default {
    methods: {
        toggleProfile(sidebarDetails){
            sidebarDetails.classList.toggle('active')
        }
    }
}